import { DIAL_CODES as SHARED_DIAL_CODES, joinPhone, splitPhone } from "pages/Administration/Organisation/organisationContactsRules";

export const DIAL_CODES = [...SHARED_DIAL_CODES, { iso: "TR", country: "Turkey", code: "+90" }];
export const CONTACT_ROLES = ["Account Manager", "Support"];
export const sampleContacts = [
  { id: 1, name: "Punitha Natarajan", role: "Account Manager", email: "punitha@cauver.com", phone: "+91 98765 12345", active: true },
  { id: 2, name: "Rajesh Kumar", role: "Support", email: "rajesh.kumar@cauver.com", phone: "+44 7700 987654", active: true },
];

export const emptyContact = () => ({ name: "", role: "", email: "", phoneCode: "+91", phone: "", whatsappCode: "+91", whatsapp: "", designation: "", contactType: "Secondary", active: true });

export const contactToDraft = (contact) => {
  const phone = splitPhone(contact.phone);
  return { ...emptyContact(), ...contact, phoneCode: contact.phoneCode ?? phone.code, phone: contact.phoneNumber ?? phone.number, whatsappCode: contact.whatsappCode ?? "+91", whatsapp: contact.whatsappNumber ?? "" };
};

export const validateContact = (draft, contacts) => {
  const errors = {};
  if (!draft.name.trim()) errors.name = "Name is required.";
  if (!draft.role.trim()) errors.role = "Select a role.";
  const email = draft.email.trim();
  if (!email) errors.email = "Email is required.";
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "Enter a valid email address.";
  else if (contacts.some((contact) => contact.id !== draft.id && contact.email.toLowerCase() === email.toLowerCase())) {
    errors.email = "A contact with this email address already exists.";
  }
  const digits = draft.phone.replace(/[\s()-]/g, "");
  if (!digits) errors.phone = "Phone is required.";
  else if (!/^\d+$/.test(digits) || digits.length < 6 || digits.length + draft.phoneCode.length - 1 > 15) {
    errors.phone = "Enter a valid phone number.";
  } else if (draft.phoneCode === "+91" && digits.length !== 10) errors.phone = "Enter a 10-digit phone number.";
  if (!/^\+\d{1,4}$/.test(draft.phoneCode)) errors.phone = "Select a country code.";
  if (!["Primary", "Secondary"].includes(draft.contactType)) errors.contactType = "Select a contact type.";
  const whatsapp = draft.whatsapp.replace(/[\s()-]/g, "");
  if (whatsapp && (!/^\d+$/.test(whatsapp) || whatsapp.length < 6 || whatsapp.length + draft.whatsappCode.length - 1 > 15 || (draft.whatsappCode === "+91" && whatsapp.length !== 10))) errors.whatsapp = "Enter a valid WhatsApp number.";
  if (whatsapp && !/^\+\d{1,4}$/.test(draft.whatsappCode)) errors.whatsapp = "Select a country code.";
  return errors;
};

export const upsertContact = (contacts, draft) => {
  const saved = {
    id: draft.id ?? Math.max(0, ...contacts.map((contact) => contact.id)) + 1,
    name: draft.name.trim(), role: draft.role, email: draft.email.trim(),
    phone: joinPhone(draft.phoneCode, draft.phone), active: Boolean(draft.active),
  };
  return draft.id === undefined ? [...contacts, saved] : contacts.map((contact) => contact.id === draft.id ? saved : contact);
};
